import { useTranslation } from "react-i18next";
import { useAuth } from "../../auth/auth-context";
import "./pending.css";

/**
 * Landing for a self-registered corporate account that has no role yet
 * (autoregistro sin rol). They wait here until an Admin assigns a role.
 */
export const Pending = () => {
  const { t } = useTranslation("shell");
  const { user, signOut } = useAuth();

  return (
    <div className="pending">
      <div className="pending-frame">
        <h1 className="pending-title">{t("pending_title")}</h1>
        <p className="pending-body">{t("pending_body", { email: user?.email ?? "" })}</p>
        <button type="button" className="pending-action" onClick={() => void signOut()}>
          {t("sign_out")}
        </button>
      </div>
    </div>
  );
};
